import { render, staticRenderFns } from "./ContinueAsGuestAccountBenefitList.vue?vue&type=template&id=6708bf83"
import script from "./ContinueAsGuestAccountBenefitList.vue?vue&type=script&lang=js"
export * from "./ContinueAsGuestAccountBenefitList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports